/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Low_Credit_Banner_UpgradeInputs */

const en_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade plan`)
};

const de_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgraden`)
};

const fr_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorer`)
};

const es_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar`)
};

const it_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const nl_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgraden`)
};

const pl_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz`)
};

const fi_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä`)
};

const da_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader`)
};

const sv_low_credit_banner_upgrade = /** @type {(inputs: Low_Credit_Banner_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera`)
};

/**
* | output |
* | --- |
* | "Upgrade plan" |
*
* @param {Low_Credit_Banner_UpgradeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const low_credit_banner_upgrade = /** @type {((inputs?: Low_Credit_Banner_UpgradeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Credit_Banner_UpgradeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_low_credit_banner_upgrade(inputs)
	if (locale === "fr") return fr_low_credit_banner_upgrade(inputs)
	if (locale === "es") return es_low_credit_banner_upgrade(inputs)
	if (locale === "it") return it_low_credit_banner_upgrade(inputs)
	if (locale === "nl") return nl_low_credit_banner_upgrade(inputs)
	if (locale === "pl") return pl_low_credit_banner_upgrade(inputs)
	if (locale === "fi") return fi_low_credit_banner_upgrade(inputs)
	if (locale === "da") return da_low_credit_banner_upgrade(inputs)
	if (locale === "sv") return sv_low_credit_banner_upgrade(inputs)
	return en_low_credit_banner_upgrade(inputs)
});